/* <trust-bar> — rotates the USP line on mobile and re-inits the Trustpilot
   widget when the section reloads in the theme editor. Fails safe: if anything
   is missing it simply shows the first USP and never blocks the page. */
(function () {
  if (customElements.get('trust-bar')) return;

  var mqMobile = window.matchMedia('(max-width: 999px)');
  var mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  class TrustBar extends HTMLElement {
    connectedCallback() {
      // Headline is desktop-only, excluded from the mobile rotation set.
      this.items = Array.prototype.slice.call(this.querySelectorAll('.trust-usp:not(.trust-usp--headline)'));
      this.index = 0;
      this.timer = null;
      this.speed = parseInt(this.getAttribute('data-rotate-speed'), 10) || 4000;

      this._boundResume = this.startRotation.bind(this);
      this._boundPause = this.stopRotation.bind(this);
      this._boundEnv = this.evaluate.bind(this);

      this.addEventListener('mouseenter', this._boundPause);
      this.addEventListener('mouseleave', this._boundResume);
      this.addEventListener('focusin', this._boundPause);
      this.addEventListener('focusout', this._boundResume);
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', this._boundEnv);

      // Pause rotation while the bar is scrolled out of view.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) this._boundResume();
              else this._boundPause();
            }.bind(this));
          }.bind(this),
          { threshold: 0 }
        );
        this.observer.observe(this);
      } else {
        this.startRotation();
      }

      this.initTrustpilot();
    }

    disconnectedCallback() {
      this.stopRotation();
      if (this.observer) this.observer.disconnect();
      if (mqMobile.removeEventListener) mqMobile.removeEventListener('change', this._boundEnv);
    }

    evaluate() {
      // Media query changed (e.g. rotate on resize into mobile).
      this.stopRotation();
      this.setActive(0);
      this.startRotation();
    }

    startRotation() {
      if (this.timer || this.items.length < 2) return;
      if (!mqMobile.matches || mqReduced.matches) return;
      this.timer = window.setInterval(this.next.bind(this), this.speed);
    }

    stopRotation() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.setActive((this.index + 1) % this.items.length);
    }

    setActive(i) {
      if (!this.items.length) return;
      this.items[this.index].classList.remove('is-active');
      this.index = i;
      this.items[this.index].classList.add('is-active');
    }

    initTrustpilot() {
      if (!window.Trustpilot) return;
      var widgets = this.querySelectorAll('.trustpilot-widget');
      for (var i = 0; i < widgets.length; i++) {
        try {
          window.Trustpilot.loadFromElement(widgets[i], true);
        } catch (e) {
          /* widget will still auto-init from the bootstrap script */
        }
      }
    }
  }

  customElements.define('trust-bar', TrustBar);
})();
